export default __webpack_public_path__ + "assets/images/ae9ba10512ba316f184887c1756f1a63.png";